<template lang="">
  <div
    v-if="
      user.permissions.indexOf(permissionsAll.step_list) >= 0 ||
        user.person.types_person.id === 3
    "
  >
    <StepCard />
  </div>
</template>
<script>
import { StepCard } from "../../components/steps";
import permissions from "../../helpers/permissions";
import { mapState } from "vuex";
export default {
  name: "StepsView",
  components: {
    StepCard,
  },
  data() {
    return {
      permissionsAll: permissions,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>
